import { E_SIGN_FAILURE, E_SIGN_REQUEST, E_SIGN_SUCCESS } from '../actions/e_sign'

export const eSign = (
  state = {
    isFetching: false,
    results: [],
    errorMessage: null,
    count: 0,
    requestUrl: '',
  },
  action
) => {
  switch (action.type) {
    case E_SIGN_REQUEST:
      return { ...state, isFetching: true, errorMessage: null }
    case E_SIGN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        results: action.response.results,
        errorMessage: null,
        count: action.response.count,
        requestUrl: action.requestUrl,
      }
    case E_SIGN_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.error,
        requestUrl: action.requestUrl,
      }
    default:
      return state
  }
}
